import { t } from "@lingui/macro";
import React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MastercardIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 19 12"
      width={24}
      height={24}
      title={t`Mastercard`}
      {...props}
    >
      <Circle cx="13" cy="6" r="6" fill="#E9A241" />
      <Circle cx="6" cy="6" r="6" fill="#D1302D" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 10.8739C11.0141 9.78476 12 8.00752 12 5.99999C12 3.99246 11.0141 2.21522 9.5 1.12604C7.98593 2.21522 7 3.99246 7 5.99999C7 8.00752 7.98593 9.78476 9.5 10.8739Z"
        fill="#EB6A2D"
      />
    </Icon>
  );
};
